/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type MissionStatus = typeof MissionStatus[keyof typeof MissionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MissionStatus = {
  Draft: 'Draft',
  PendingCommittee: 'PendingCommittee',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Active: 'Active',
  Closed: 'Closed',
  Cancelled: 'Cancelled',
} as const;
